// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__XGrsZ","Error":"Input_Error__24U1i"};